import React from 'react';
import { graphql, createRefetchContainer } from 'react-relay';

import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Drawer from '@material-ui/core/Drawer';
import { useCommonStyles } from '../common/Styles';
import TableFieldMeta from '../../common/TableFieldMeta';
import InnerTabFilterGridItemTextField from '../common/innerTab/InnerTabFilterGridItemTextField';
import BaseGridContainer from '../common/BaseGridContainer';
import { ROWS_PER_PAGE } from '../../common/constants';
import { createQueryRendererProgressV2 } from '../common/QueryRendererProgressV2';
import TablePaginator from '../common/TablePaginator';
import BrokerActivityActions from '../activityIB/BrokerActivityActions';
import notiStack from '../../common/notiStack';
import BrokerActivityDetails from '../activity/BrokerActivityDetails';

const processedAtIsnullDefault = null;
const ignoredDefault = null;

function BankCashTransactionList(props) {
  const {
    viewer,
    relay,
    filter,
  } = props;
  filter.setRelay(relay);

  const [detailsOpen, setDetailsOpen] = React.useState(false);
  const [brokerActivity, setBrokerActivity] = React.useState(null);

  const classes = useCommonStyles();
  const columns = [
    TableFieldMeta.localId,
    TableFieldMeta.processedAt,
    TableFieldMeta.processedBy,
    TableFieldMeta.priceField('amount', 'Amount', 'amount', 'currency', 2),
    TableFieldMeta.field('remitterReference', 'Remitter Ref.', {
      align: 'center',
    }),
    TableFieldMeta.field('transactionReference', 'Txn Ref.', {
      align: 'center',
      width: 300,
    }),
    TableFieldMeta.field('otherPartyAccountName', 'OP. AccName', {
      width: 200,
    }),
    TableFieldMeta.field('otherPartySortCode', 'OP. SC.', {
      align: 'center',
      width: 100,
    }),
    TableFieldMeta.field('otherPartyAccountNumber', 'OP. AccNo', {
      width: 100,
    }),
    TableFieldMeta.notes(row => row.value),
    {
      id: 'actions',
      accessor: node => node,
      Header: '',
      Cell: row => (
        <BrokerActivityActions
          brokerActivity={row.value}
          onProcess={(be) => {
            if (be.transType === 'Deposits/Withdrawals') {
              notiStack.warning(
                'Deposits/Withdrawals must be processed in transfers page',
              );
              return;
            }
            setBrokerActivity(be);
            // setDrawerOpen(true);
          }}
          onShowDetails={(be) => {
            setBrokerActivity(be);
            setDetailsOpen(true);
          }}
        />
      ),
    },
  ];
  return (
    <div className={classes.innerTabRoot}>
      <Drawer
        anchor="right"
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
      >
        <div tabIndex={0} role="button">
          <BrokerActivityDetails brokerActivity={brokerActivity} />
        </div>
      </Drawer>

      <BaseGridContainer>
        <InnerTabFilterGridItemTextField
          id="search-filter"
          label="Custom Search"
          helperText="symbol, description"
          defaultValue={filter.params.search}
          onChange={e => filter.updateVar('search', e.target.value)}
        />

        <Grid item xs={12}>
          <TablePaginator
            columns={columns}
            filter={filter}
            getDataNode={() => (viewer ? viewer.bankCashTransactions : null)}
            // tableRender={RTTableRenderer}
          />
        </Grid>
      </BaseGridContainer>
    </div>
  );
}

BankCashTransactionList.propTypes = {
};

BankCashTransactionList.defaultProps = {
};

const query = graphql`
  query BankCashTransactionListQuery (
    $first: Int
    $offset: Int
    $search: String
    $reportDate: Date
    $processedAt_Isnull: Boolean
    $ignored: Boolean
  ) {
    viewer {
      ...BankCashTransactionList_viewer
      @arguments (
        first: $first
        offset: $offset
        search: $search
        reportDate: $reportDate
        processedAt_Isnull: $processedAt_Isnull
        ignored: $ignored
      )
    }
  }
`;

const container = createRefetchContainer(
  BankCashTransactionList,
  {
    viewer: graphql`
      fragment BankCashTransactionList_viewer on Query
      @argumentDefinitions(
        first: {type: Int, defaultValue: 10}
        offset: {type: Int}
        search: {type: String}
        reportDate: {type: Date}
        processedAt_Isnull: {type: Boolean}
        ignored: {type: Boolean}
      ) {
        
        bankCashTransactions(
          first: $first
          offset: $offset
          search: $search
          reportDate: $reportDate
          processedAt_Isnull: $processedAt_Isnull
          ignored: $ignored
        ) {
          count
          edges {
            node {
              ...BankCashTransaction_all @relay(mask: false)
            }
          }
          pageInfo {
            endCursor
            startCursor
            hasNextPage
            hasPreviousPage
          }
        }
      }
    `,
  },
  query,
);
export default withRouter(
  createQueryRendererProgressV2(
    query,
    container,
    {},
    ({ rowsPerPage }) => ({
      first: rowsPerPage || ROWS_PER_PAGE,
      search: null,
      reportDate: null,
      processedAt_Isnull: processedAtIsnullDefault,
      ignored: ignoredDefault,
    }),
    {
      debounceFields: ['search', 'symbol', 'conId', 'currency'],
    },
  ),
);
